/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-profil-week-end-5': {
    width: 47,
    height: 38,
    viewBox: '0 0 47 38',
    data: '<path pid="0" class="st0" d="M2.9 35V22.1c.7.6 1.6 1 2.6 1.1v9.5h35.7v-9.5c1-.2 1.8-.6 2.6-1.1V35H2.9zm5.4-11.7h30v6.5h-30v-6.5zm16.6-2.8h-3.2v-1.6h3.2v1.6zM43.6 8.8l-.5 8.8c-.1 1.6-1.3 2.8-2.9 2.9H27.8v-4.4h-8.9v4.4H6.3c-1.5-.1-2.8-1.3-2.9-2.9L3 8.8h40.6zM19.1 3.4c2.2-.5 5.1-.8 8.4 0V6h-8.4V3.4zM46.6 6H30.4V4.3c.5.2 1 .5 1.5.7l1.3-2.5C27.6-.5 22.6-.3 19.4.3c-3.5.7-5.7 2.2-5.8 2.2L15.1 5s.4-.3 1.2-.6V6H0l.1 1.5v30.4h46.5V6z"/>'
  }
})
